import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { RestapiService } from '../../services/restapi.service';
import { RoutingService } from '../../services/routing.service';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-trivia',
  templateUrl: './trivia.component.html',
  styleUrls: ['./trivia.component.scss']
})
export class TriviaComponent implements OnInit, OnDestroy {

  @ViewChild('content') content;

  timeLeft: number = 20;
  interval: any;
  limit = 10;

  url: any;
  category: any;
  all: any;
  trivias: any;

  title: string = "";

  score: number = 0;
  current: number = 0;
  selected: number = 0;

  isCorrect: boolean = false;

  gameStatus = 'stop';
  //gameStatus = 'finished';
  private routeObs: Subscription;
  constructor(
    private activatedRoute: ActivatedRoute,
    public api: RestapiService,
    public route: RoutingService,
    private modalService: NgbModal
  ) {

    this.routeObs = this.route.onRouteChange.subscribe(res => {
      console.log('routeObs change')
      setTimeout(() => {
        this.route.setCurrent(window.location.pathname);
        this.loadGame();
      }, 10);
    });
  }

  ngOnInit(): void {

    this.loadGame();
    setTimeout(() => {
      //  this.openGameModal(this.content);
    }, 100);
  }

  loadGame() {
    this.category = this.activatedRoute.snapshot.paramMap.get('category');
    this.url = this.activatedRoute.snapshot.paramMap.get('game');
    console.log('category', this.category);
    // let params = {};
    switch (this.url) {
      case 'incendios-forestales':

        this.api.getdata('websection', (this.category != 'random') ?
          {
            filters: {
              id: { value: this.category },
            }
          } :
          {
            filters: {
              webroute_id: { value: 9 },
              webcontext_id: { value: 12 },
            }
          })
          .subscribe(res => {
            if (res.status === true) {
              console.log('AREAS SELECCIONADA', res.result.data);
              this.all = [];

              this.title = (res.result.data.length > 1) ? 'Juego aleatorio' : res.result.data[0].name;

              res.result.data.forEach(el => {
                el.webtrivia.forEach(trivia => {
                  this.all.push(trivia);
                });
              });

              console.log('TODAS', this.all);
              let shuffled = this.shuffleArray(this.all);
              console.log('MEZCLADAS', shuffled);
              this.trivias = [];
              this.limit = this.all.length >= 10 ? 10 : this.all.length;
              console.log('LIMITE DEFINIDO', this.limit)
              for (let i = 0; i < this.limit; i++) {
                this.trivias.push(shuffled[i]);
              }
              console.log('SELECCIONADAS', this.trivias, this.trivias.length);
            }
          });

        break;
      case 'humedales':
        this.api.getdata('websection', (this.category != 'random') ?
          {
            filters: {
              id: { value: this.category },
            }
          } :
          {
            filters: {
              webroute_id: { value: 9 },
              webcontext_id: { value: 13 },
            }
          })
          .subscribe(res => {
            if (res.status === true) {
              console.log('AREAS SELECCIONADA', res.result.data);
              this.all = [];

              this.title = (res.result.data.length > 1) ? 'Juego aleatorio' : res.result.data[0].name;

              res.result.data.forEach(el => {
                el.webtrivia.forEach(trivia => {
                  this.all.push(trivia);
                });
              });

              console.log('TODAS', this.all);
              let shuffled = this.shuffleArray(this.all);
              console.log('MEZCLADAS', shuffled);
              this.trivias = [];
              this.limit = this.all.length >= 10 ? 10 : this.all.length;
              console.log('LIMITE DEFINIDO', this.limit)
              for (let i = 0; i < this.limit; i++) {
                this.trivias.push(shuffled[i]);
              }
              console.log('SELECCIONADAS', this.trivias, this.trivias.length);
            }
          });

        break;
    }
  }

  shuffleArray(array: any) {
    let m = array.length, t, i;
    let exit = Object.assign({}, this.all);
    while (m) {
      i = Math.floor(Math.random() * m--);
      t = exit[m];
      exit[m] = exit[i];
      exit[i] = t;
    }
    return exit;
  }

  openGameModal(content) {
    document.documentElement.style.setProperty('--modal-backdrop', (this.isCorrect === true) ? '#719BAFCC' : '#876791CC');
    let statusCss = (this.isCorrect === true) ? 'success' : 'fail';
    const modal = this.modalService.open(content, { windowClass: "app-modal modal-game " + statusCss + " animate__slow animate__animated animate__fadeInUp" });
    modal.result.then(
      () => { this.play(); console.log('When user closes'); },
      () => { this.play(); console.log('Backdrop click'); }
    )
  }

  choose(trivia, option) {
    if (this.gameStatus == 'play') {
      this.selected = option;
      this.isCorrect = (option == trivia.correct_option);
      (this.isCorrect === true) ? this.score++ : '';
      console.log('PUNTAJE', this.score);
      this.pause();
      setTimeout(() => {
        this.openGameModal(this.content);
      }, 10);
    }


  }

  restart() {
    location.reload()
  }

  play() {
    this.selected = 0;
    this.isCorrect = false;
    this.current++;
    (this.current > this.limit) ? this.gameStatus = 'finished' : this.gameStatus = 'play';
    this.startTimer();
  }

  startTimer() {
    this.timeLeft = 20;
    this.interval = setInterval(() => {
      if (this.timeLeft > 0 && this.gameStatus == 'play') {
        this.timeLeft--;
      }
      else {
        if (this.gameStatus != 'finished') {
          this.pause();
          //this.gameStatus = 'pause';
          this.openGameModal(this.content)
        }
      }
    }, 1000)
  }

  pause() {
    clearInterval(this.interval);
    this.timeLeft = 0;
    this.gameStatus = 'pause';
  }

  ngOnDestroy():void{
    clearInterval(this.interval);
    this.timeLeft = 0;
  }

}
